import { ActionTree, Module, MutationTree } from 'vuex'
import { RootState } from '@/interfaces/store/root'
import * as campaignService from '@/services/campaign-bff/v1/campaigns'
import * as campaignCustomerService from '@/services/campaign-bff/v1/customers'
import { Actions, Mutations, CampaignInfoPayload, CampaignInfoState } from '@/interfaces/store/campaignInfo'
import { CampaignList } from '@/interfaces/campaign-info'

export const state: CampaignInfoState = {
  token: '',
  campaign: {
    isLoading: true,
    items: []
  },
  campaignRegister: {
    isLoading: true
  }
}

export const actions: ActionTree<CampaignInfoState, RootState> & Actions = {
  async fetchCampaignList({ commit }, payload: CampaignInfoPayload) {
    commit('updateCampaignIsLoading', true)
    commit('updateCampaignList', [])

    try {
      const { token } = payload
      if (token) {
        const result = await campaignService.getCampaigns(token)
        const statusCode = result.httpStatusCode
        if (statusCode === 200) { 
          const response: CampaignList[] = result.json.data.length > 0 ? result.json.data : []
          commit('updateCampaignList', response)
          commit('updateCampaignIsLoading', false)
        } else {
          throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
        }
      }
    } catch (error) {
      console.log(error)
    }
    commit('updateCampaignIsLoading', false)
  },
  async fetchCampaignRegister({ commit }, payload: CampaignInfoPayload) {
    commit('updateCampaignRegisterIsLoading', true)

    try {
      const { token, campaignId } = payload
      if (token && campaignId) {
        const result = await campaignCustomerService.registerCampaign(token, campaignId)
        const statusCode = result.httpStatusCode
        if (statusCode === 201) { 
          // Refresh campaign list after successful registration
          const responseCampaigns = await campaignService.getCampaigns(token)
          const campaigns: CampaignList[] = responseCampaigns.json.data.length > 0 ? responseCampaigns.json.data : []

          commit('updateCampaignList', campaigns)
          commit('updateCampaignRegisterIsLoading', false)
        } else {
          throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
        }
      }
    } catch (error) {
      console.log(error)
    }
    commit('updateCampaignRegisterIsLoading', false)
  }
}

export const mutations: MutationTree<CampaignInfoState> & Mutations = {
  updateCampaignIsLoading(state: CampaignInfoState, loading: boolean) {
    state.campaign.isLoading = loading
  },
  updateCampaignList(state: CampaignInfoState, campaignList: CampaignList[]) {
    state.campaign.items = campaignList
  },
  updateCampaignRegisterIsLoading(state: CampaignInfoState, loading: boolean) {
    state.campaignRegister.isLoading = loading
  }
}

export const store: Module<CampaignInfoState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}
